import axiosCall from 'src/services/axiosHelper';

export async function getUserPreference(preference: string, defaultValue: string): Promise<boolean> {
  const data =  await axiosCall<string>({
    method: 'get',
    url: `/profile-settings/preferences/${preference}/default/${defaultValue}`,
  }, defaultValue);
  return data !== defaultValue;
}

export async function setUserPreference(preference: string, value: string): Promise<void> {
  await axiosCall<string>({
    method: 'put',
    url: `/profile-settings/preferences/${preference}/value/${value}`,
  });
}